
(function () {
  'use strict';
  if (window.DaLucaReadyMilitaryV371) return;
  window.DaLucaReadyMilitaryV371 = true;

  function directItems(group) {
    if (!group) return [];
    var ul = group.querySelector(':scope > ul');
    if (ul) {
      var lis = Array.from(ul.children).filter(function(n){ return n.tagName === 'LI'; });
      if (lis.length) return lis;
    }
    return Array.from(group.children).filter(function(n){
      return n.nodeType === 1 && !/^(SCRIPT|STYLE)$/i.test(n.tagName);
    });
  }

  function appendCleanChildren(source, target) {
    Array.from(source.childNodes).forEach(function(node){
      var clone = node.cloneNode(true);
      if (clone.nodeType === 1) {
        clone.removeAttribute('style');
        clone.removeAttribute('class');
        clone.querySelectorAll('[style]').forEach(function(n){ n.removeAttribute('style'); });
        clone.querySelectorAll('[class]').forEach(function(n){ n.removeAttribute('class'); });
        clone.querySelectorAll('li').forEach(function(n){
          n.style.listStyle = 'none';
          n.style.margin = '0';
          n.style.padding = '0';
        });
      }
      target.appendChild(clone);
    });
  }

  function makeFeatureSection(calloutGroup) {
    var items = directItems(calloutGroup).slice(0,6);
    if (!items.length) return null;

    var sec = document.createElement('section');
    sec.className = 'daluca-ready-military-editorial-v371__features';
    sec.setAttribute('aria-label','One-piece strap construction and fit');

    var grid = document.createElement('div');
    grid.className = 'daluca-ready-military-feature-grid-v371';

    items.forEach(function(item){
      var card = document.createElement('article');
      card.className = 'daluca-ready-military-feature-card-v371';
      appendCleanChildren(item, card);
      grid.appendChild(card);
    });

    sec.appendChild(grid);
    return sec;
  }

  function makeMaterialSection(types) {
    if (!types) return null;
    var items = directItems(types).slice(0,4);
    if (!items.length) return null;

    var sec = document.createElement('section');
    sec.className = 'daluca-ready-military-editorial-v371__materials';
    sec.setAttribute('aria-label','Horween leather options');

    var eyebrow = document.createElement('span');
    eyebrow.className = 'daluca-ready-military-editorial-v371__eyebrow';
    window.DaLucaI18n.setText(eyebrow, 'Horween leathers');

    var h2 = document.createElement('h2');
    window.DaLucaI18n.setText(h2, 'Choose the character that fits your watch');

    var grid = document.createElement('div');
    grid.className = 'daluca-ready-military-material-grid-v371';

    items.forEach(function(item){
      var card = document.createElement('article');
      card.className = 'daluca-ready-military-material-card-v371';
      appendCleanChildren(item, card);
      grid.appendChild(card);
    });

    sec.appendChild(eyebrow);
    sec.appendChild(h2);
    sec.appendChild(grid);
    return sec;
  }

  function rebuild(details) {
    if (!details) return;

    // Remove every previous generated version before building the final one.
    details.querySelectorAll(
      '.daluca-ready-military-editorial-v368,' +
      '.daluca-ready-military-editorial-v369,' +
      '.daluca-ready-military-editorial-v370,' +
      '.daluca-ready-military-editorial-v371'
    ).forEach(function(n){ n.remove(); });

    var source = details.querySelector('.daluca-product-details__description');
    if (!source) return;

    var callouts = Array.from(source.querySelectorAll('.product-callouts'));
    var types = source.querySelector('.product-types');
    if (!callouts.length && !types) return;

    var shell = document.createElement('div');
    shell.className = 'daluca-ready-military-editorial-v371';

    // Only the first six-icon group is appropriate to one-piece military.
    var featureSec = makeFeatureSection(callouts[0]);
    if (featureSec) shell.appendChild(featureSec);

    var materialSec = makeMaterialSection(types);
    if (materialSec) shell.appendChild(materialSec);

    source.hidden = true;
    source.setAttribute('aria-hidden','true');
    source.insertAdjacentElement('afterend', shell);
  }

  function removeTwoPieceFeatureStrip() {
    if (!document.querySelector('.daluca-pdp--ready-leather-military')) return;

    // Directly remove the old V9.9 injected strip.
    document.querySelectorAll('.daluca-v99-live-six').forEach(function(n){ n.remove(); });

    // Defensive semantic removal for any older duplicate that may not carry
    // the V9.9 class but still contains the exact two-piece image set.
    var needles = [
      '1oak-heavy-duty3.jpg',
      '1oak-design2.jpg',
      '1oak-comfort2.jpg',
      '1oak-buckle.jpg',
      '1oak-thread.jpg',
      '1oak-fitmtoc.jpg'
    ];

    var imgs = Array.from(document.images).filter(function(img){
      if (img.closest('.daluca-ready-military-editorial-v371')) return false;
      var src = [
        img.currentSrc,
        img.src,
        img.getAttribute('data-src'),
        img.getAttribute('srcset')
      ].filter(Boolean).join(' ');
      return needles.some(function(name){ return src.indexOf(name) !== -1; });
    });

    if (!imgs.length) return;

    var candidates = new Set();
    imgs.forEach(function(img){
      var node = img.parentElement;
      for (var i=0; node && node !== document.body && i<8; i++, node=node.parentElement) {
        var count = Array.from(node.querySelectorAll('img')).filter(function(test){
          var src = [
            test.currentSrc,
            test.src,
            test.getAttribute('data-src'),
            test.getAttribute('srcset')
          ].filter(Boolean).join(' ');
          return needles.some(function(name){ return src.indexOf(name) !== -1; });
        }).length;
        if (count >= 4 && count <= 8) {
          candidates.add(node);
          break;
        }
      }
    });

    candidates.forEach(function(node){
      if (!node.closest('.daluca-ready-military-editorial-v371')) node.remove();
    });
  }

  function normalizeAddons(root) {
    if (!root) return;
    var setup = root.querySelector('.daluca-master-addons-v366');
    if (!setup) return;

    setup.classList.add('daluca-master-addons-v371');

    var heading = setup.querySelector('.daluca-master-addons-v366__heading h3');
    if (heading) window.DaLucaI18n.setText(heading, 'Care & Installation');

    var kicker = setup.querySelector('.daluca-master-addons-v366__heading .daluca-concierge-kicker');
    if (kicker) window.DaLucaI18n.setText(kicker, 'Complete the setup');
  }

  function run() {
    var root = document.querySelector('.daluca-pdp--ready-leather-military');
    if (!root) return;

    var details = document.querySelector('.daluca-product-details--ready-military');
    if (details && details.dataset.dalucaReadyMilitaryV371 !== 'true') {
      rebuild(details);
      details.dataset.dalucaReadyMilitaryV371 = 'true';
    }

    normalizeAddons(root);
    removeTwoPieceFeatureStrip();
  }

  var timer = 0;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(function(){
      var details = document.querySelector('.daluca-product-details--ready-military');
      if (details && !details.querySelector('.daluca-ready-military-editorial-v371')) {
        details.dataset.dalucaReadyMilitaryV371 = 'false';
      }
      run();
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',run,{once:true});
  } else {
    run();
  }

  if (document.body) {
    new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
  }

  [120,350,750,1300,2200,3600].forEach(function(ms){ setTimeout(run,ms); });
})();

